module.exports = __webpack_public_path__ + "static/media/header-background.c850c3d3.jpg";